<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <el-button class="title_btn" type="primary" size="" v-if="userInfo.g_idx  > 2 " @click="addBtn()">등록</el-button>
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <div class="table_search">
              <el-row>
                <el-col :span="12">
                  <span class="t_s_title">검색</span>
                  <el-select
                    v-model="tableSelected"
                    placeholder="Select"
                    class="table_s_select"
                  >
                    <el-option
                      v-for="item in tableSelectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input class="table_s_input"
                            v-model="tableSearch"
                            size=""
                            placeholder="검색어를 입력해주세요."
                            @keyup.enter.native="[getList(), page=1]"
                  />
                </el-col>
              </el-row>
            </div>
            <div class="search_btn_wrap text_center">
              <el-button type="primary" @click="[getList(), page=1]">검색</el-button>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%"
              empty-text="데이터가 없습니다."
              v-loading="tableLoading"
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width

                               :class-name = header.class
              ></el-table-column>
              <el-table-column v-if="tableoption"
                               align="center"
                               width="250"
                               label="옵션"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
                  <el-button
                    size="mini"
                    type="info"
                    @click="handleProduct(scope.$index, scope.row)">제품</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size = filterPagnation.size
              :pager-count = filterPagnation.pagerCount
              layout="prev, pager, next"
              :current-page.sync = page
              :total="listTotal"
              @current-change="getList"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import sessionStorage from '@/mixins/sessionStorage';
  import localStorage from '@/mixins/localStorage'
  import util from '@/mixins/util'
  import {countryList} from "@/service/countryService";

  let params = {};
  export default {
    name: "License",
    components: {},
    mixins: [ VuxAlert, sessionStorage ,localStorage ],
    data(){
      return{
        userInfo : this.getUserInfo(),
        c_idx : 1,
        category : [],
        tableLoading: true,
        data : {},
        title: this.$route.meta.title,
        tableData: [],
        tableSearch: '',
        tableHeader: [
          {
            label : 'code',
            prop : 'pl_code',
            class: 'text_center'
          },{
            label: '타이틀',
            prop: 'pl_title',
            class: 'text_center'
          },{
            label: '생성일',
            prop: 'created_at',
            width: 250,
            class: 'text_center'
          }
        ],
        tableoption: true,
        pagnation: {
          size: 10,
          pagerCount: 11,
          page: 1,
        },
        page : 1,
        lastPage: 0,
        listTotal: 0,
        tableSelected: '',
        tableSelectOption: [
          {
            label: '타이틀',
            value: 'pl_title'
          }
        ],
        filterType: '',
        filterTypeList: [],
        filterSet : '',
        category: [],
      }
    },

    created() {
    },
    computed: {
      tableFilter() {
        return this.tableData
      },
      filterPagnation() {
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getCountryList();
      this.getList();
    },

    beforeRouteLeave(to, from, next){
      if(to.path === "/auth" && this.$route.query.first){
        next(false);
      }else{
        return next();
      }
    },

    methods: {
      getCountryList(){
        this.$api.$user.getCountry()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = countryList;
          });
      },
      addBtn(){
        this.$router.push('/license/detail');
      },

      resetPage() {
        this.page = 1
      },
      getList() {
        this.tableLoading = true;
        params = {
          page: this.page,
          type : 'pinostory',
          ip : 1,
          c_idx : this.c_idx,
        }

        if(this.tableSearch != '') {
          params[this.tableSelected] = this.tableSearch
        }
        this.$api.$product.getLicenceList(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }else{
            this.tableData = [];
            this.page = 1;
            this.lastPage = 0;
            this.listTotal = 0;
          }
          this.tableLoading = false;
        })
      },

      handleEdit(index, row) {
        this.$router.push('/license/detail/'+row.pl_idx);
      },

      handleDelete(index, row) {
        let alertParams = {'element' : this , 'key' : row.pl_idx };
        this.listDeleteAlert(alertParams);
      },
      handleProduct(index, row) {
        let url = `/license/detail/${row.pl_idx}/product`
        window.open(`${location.protocol}//${location.host}${url}`)
      },
      dataDelete(key){
        let params = {'pl_idx' : key , type :'pinostory'};
        this.$api.$license.deleteLicense(params).then( res => res.Data.Result).then(res => {
          if(res.Info.status === true){
            this.page = 1;
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.reason);
          }
        })
      },

      tableIndex(index) {
        return index + this.pagnation.size * (this.page - 1) +1
      },
    }
  }

</script>
